<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="image" id="fig_2.1"><span epub:type="pagebreak" id="page_30" title="30"><a id="fig_30"></a><img alt="" src="images/f030-01.jpg" style="width: 100%;"/></span></p>
<p class="caption"><b>Fig. 2.1.</b> A speculative reconstruction of <i>Weichselia reticulata</i>. Artwork by Joschua Knüppe.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter02.vue?61e31caa